// extracted by mini-css-extract-plugin
export default {"commentBox":"EditMemberStatusModal_commentBox__g77MS","commentList":"EditMemberStatusModal_commentList__Q7SZa"};